import React from 'react';
import { FaMoon, FaSun, FaTimes, FaTrash, FaMinus } from 'react-icons/fa';
import { EduGenieAvatarImg } from './edugenieBrand';

const ChatHeader = ({
  botName,
  tagline,
  panelType,
  theme,
  onToggleTheme,
  onClear,
  onMinimize,
  onClose
}) => {
  const panelLabel = {
    admin: 'Admin',
    user: 'Learner',
    org: 'Organization',
    instructor: 'Instructor'
  }[panelType] || null;

  return (
  <header className="edugenie-header">
    <div className="edugenie-header-avatar" aria-hidden="true">
      <EduGenieAvatarImg className="edugenie-brand-img" alt="" />
    </div>
    <div className="edugenie-header-meta">
      <h2 className="edugenie-header-title">{botName || 'EduGenie'}</h2>
      <p className="edugenie-header-subtitle">{tagline || 'Your Intelligent Learning Assistant'}</p>
      <div className="edugenie-liberate-badge" aria-label="Liberate branding">
        <span className="edugenie-liberate-dot" aria-hidden="true" />
        Liberate
        {panelLabel ? (
          <>
            <span className="edugenie-panel-sep" aria-hidden="true">·</span>
            <span className="edugenie-panel-label">{panelLabel}</span>
          </>
        ) : null}
      </div>
    </div>
    <div className="edugenie-header-actions">
      <button
        type="button"
        className="edugenie-icon-btn"
        onClick={onToggleTheme}
        aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
      >
        {theme === 'dark' ? <FaSun /> : <FaMoon />}
      </button>
      <button
        type="button"
        className="edugenie-icon-btn"
        onClick={onClear}
        aria-label="Clear chat history"
        title="Clear chat"
      >
        <FaTrash />
      </button>
      <button
        type="button"
        className="edugenie-icon-btn"
        onClick={onMinimize}
        aria-label="Minimize chat"
        title="Minimize"
      >
        <FaMinus />
      </button>
      <button
        type="button"
        className="edugenie-icon-btn"
        onClick={onClose}
        aria-label="Close chat"
        title="Close"
      >
        <FaTimes />
      </button>
    </div>
  </header>
  );
};

export default ChatHeader;
